"use client";

import React from "react";
import { Phone, Truck, Wrench, RotateCcw } from "lucide-react";
const IMAGE_URL = "https://upward-sunbeam.10web.cloud/wp-content/uploads/2026/05/ChatGPT-Image-May-5-2026-02_58_52-AM.png";
export default function ServiceProcess() {
  return <section id="pickup" className="relative w-full overflow-hidden bg-white">
      <div className="relative w-full min-h-[590px] lg:min-h-[520px] flex items-start lg:items-center">
        {/* IMAGE */}
        <img src={IMAGE_URL} alt="Nova Tire Center pickup tire service" className="absolute inset-0 w-full h-full object-cover object-[76%_center] lg:object-[82%_center] scale-[1.02] lg:scale-[1.05]" />

        {/* MOBILE TOP GRADIENT — shorter, less over the face */}
        <div className="absolute top-0 left-0 right-0 h-[165px] bg-gradient-to-b from-white/82 via-white/55 to-transparent lg:hidden z-0" />

        {/* DESKTOP LEFT GRADIENT */}
        <div className="hidden lg:block absolute left-0 top-0 h-full w-[52%] bg-gradient-to-r from-white via-white/90 to-transparent z-0" />

        {/* CONTENT */}
        <div className="relative z-10 w-full max-w-[1180px] mx-auto px-4 lg:px-6 pt-4 pb-[180px] lg:py-12">
          <div className="max-w-[390px] lg:max-w-[520px] ml-0 lg:ml-[-60px]">
            <h2 className="uppercase italic leading-[0.88] lg:leading-[0.9] tracking-tight mb-3 lg:mb-6">
              <span className="block text-black font-black text-[35px] sm:text-[42px] lg:text-[68px]">
                Flat Tire?
              </span>

              <span className="block text-[#0B4DBA] font-black text-[31px] sm:text-[38px] lg:text-[60px]">
                We Pick It Up.
              </span>

              <span className="block text-black font-black text-[25px] sm:text-[32px] lg:text-[48px]">
                You Stay Put.
              </span>
            </h2>

            <div className="w-[74px] lg:w-[90px] h-[4px] bg-[#FF5A00] mb-3 lg:mb-6" />

            {/* DESKTOP DESCRIPTION ONLY */}
            <p className="hidden lg:block text-[17px] text-[#1F2937] leading-relaxed mb-5 max-w-[470px]">
              We come to your location, remove the wheel, fix it at our shop,
              and bring it back ready to go.
            </p>

            {/* DESKTOP SHORT TEXT ONLY */}
            <p className="hidden lg:block font-black text-[#111827] text-[15px] mb-8">
              No towing. No waiting. No downtime.
            </p>

            {/* DESKTOP BUTTON ONLY */}
            <a href="tel:+14243138474" className="hidden lg:inline-flex items-center gap-3 bg-[#FF5A00] hover:bg-[#E94E00] text-white px-8 py-4 rounded-[4px] font-black uppercase text-[15px] shadow-[0_16px_30px_rgba(255,90,0,0.28)] transition">
              <Phone className="w-5 h-5" />
              Call for Pickup
            </a>
          </div>
        </div>

        {/* DESKTOP BRAND LINES */}
        <div className="absolute z-20 left-[46%] top-0 h-full w-[12px] bg-[#0B4DBA]/95 -skew-x-[13deg] hidden lg:block" />
        <div className="absolute z-20 left-[45.5%] top-[40px] h-[260px] w-[8px] bg-[#FF5A00]/90 -skew-x-[13deg] hidden lg:block" />
        <div className="absolute z-20 left-[47.2%] top-0 h-full w-[3px] bg-white/70 -skew-x-[13deg] hidden lg:block" />

        {/* MOBILE EXPLANATION BAR */}
        <div className="absolute bottom-[88px] left-0 right-0 z-20 lg:hidden bg-[#071B3A]/96 text-white px-4 py-4">
          <p className="text-[15px] leading-snug font-black text-white">
            No towing. No waiting. No downtime.
          </p>

          <p className="mt-2 text-[12px] leading-relaxed font-semibold text-white/82">
            We come to your location, remove the wheel, fix it at our shop,
            and bring it back ready to go.
          </p>
        </div>

        {/* PROCESS BAR */}
        <div className="absolute bottom-0 right-0 w-full lg:w-[50%] h-[88px] lg:h-[96px] bg-[#071B3A]/95 text-white px-3 lg:px-7 py-3 lg:py-4 overflow-hidden">
          <div className="absolute inset-0 bg-gradient-to-t from-[#071B3A] via-[#071B3A]/90 to-[#071B3A]/70" />

          <div className="relative z-10 grid grid-cols-3 gap-2 lg:gap-6 text-sm">
            <div className="flex flex-col lg:flex-row items-center lg:items-start text-center lg:text-left gap-1 lg:gap-3">
              <Truck className="w-4 h-4 lg:w-5 lg:h-5 lg:mt-1 text-white shrink-0" />
              <div>
                <div className="text-[#7DB2FF] font-black text-[10px] lg:text-xs mb-0.5 lg:mb-1">
                  01
                </div>
                <div className="font-black uppercase italic text-[10px] lg:text-[13px]">
                  Pick Up
                </div>
                <p className="text-white/70 text-[9px] lg:text-xs leading-tight">
                  We remove the wheel
                </p>
              </div>
            </div>

            <div className="flex flex-col lg:flex-row items-center lg:items-start text-center lg:text-left gap-1 lg:gap-3">
              <Wrench className="w-4 h-4 lg:w-5 lg:h-5 lg:mt-1 text-white shrink-0" />
              <div>
                <div className="text-[#7DB2FF] font-black text-[10px] lg:text-xs mb-0.5 lg:mb-1">
                  02
                </div>
                <div className="font-black uppercase italic text-[10px] lg:text-[13px]">
                  Fix It
                </div>
                <p className="text-white/70 text-[9px] lg:text-xs leading-tight">
                  Repair or replace
                </p>
              </div>
            </div>

            <div className="flex flex-col lg:flex-row items-center lg:items-start text-center lg:text-left gap-1 lg:gap-3">
              <RotateCcw className="w-4 h-4 lg:w-5 lg:h-5 lg:mt-1 text-white shrink-0" />
              <div>
                <div className="text-[#7DB2FF] font-black text-[10px] lg:text-xs mb-0.5 lg:mb-1">
                  03
                </div>
                <div className="font-black uppercase italic text-[10px] lg:text-[13px]">
                  Bring Back
                </div>
                <p className="text-white/70 text-[9px] lg:text-xs leading-tight">
                  Installed & ready
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}